import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Command = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Command" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.5 1C21.0523 1 23 2.94772 23 5.5C23 8.05228 21.0523 10 18.5 10H16V14H18.5C21.0523 14 23 15.9477 23 18.5C23 21.0523 21.0523 23 18.5 23C15.9477 23 14 21.0523 14 18.5V16H10V18.5C10 21.0523 8.05228 23 5.5 23C2.94772 23 1 21.0523 1 18.5C1 15.9477 2.94772 14 5.5 14H8V10H5.5C2.94772 10 1 8.05228 1 5.5C1 2.94772 2.94772 1 5.5 1C8.05228 1 10 2.94772 10 5.5V8H14V5.5C14 2.94772 15.9477 1 18.5 1ZM5.5 16C4.05228 16 3 17.0523 3 18.5C3 19.9477 4.05228 21 5.5 21C6.94772 21 8 19.9477 8 18.5V16H5.5ZM16 18.5C16 19.9477 17.0523 21 18.5 21C19.9477 21 21 19.9477 21 18.5C21 17.0523 19.9477 16 18.5 16H16V18.5ZM10 14H14V10H10V14ZM5.5 3C4.05228 3 3 4.05228 3 5.5C3 6.94772 4.05228 8 5.5 8H8V5.5C8 4.05228 6.94772 3 5.5 3ZM18.5 3C17.0523 3 16 4.05228 16 5.5V8H18.5C19.9477 8 21 6.94772 21 5.5C21 4.05228 19.9477 3 18.5 3Z" fill="#000" />
  </StyledIcon>
));

Command.displayName = 'Command';

export { Command };
